/** English articles intentionally unavailable under the Bulgarian locale. */
export const BG_EXCLUDED_POST_SLUGS = new Set([
  "comms-talks-series",
  "perceptica-successfully-completed-an-eu-funded-project",
  "perceptica-and-the-other-half-present-ffwd-people-are-gone",
  "now-you-can-register-for-ffwd-2-people-dont-buy",
  "aibest-hosted-the-most-significant-event-in-the-knowledge-industry-in-bulgaria-and-presented-technology-oscars-in-9-categories",
  "journalism-students-will-get-to-know-media-monitoring-and-analysis-of-social-media",
  "covid-19-infected-media",
  "brand-journalism-and-the-thin-red-line-between-marketing-success-and-taking-the-easy-way-out",
  "what-the-gamestop-case-taught-us-about-communication",
  "hells-kitchen-vs-masterchef-the-social-media-battle-of-the-chefs",
]);

export function isPostExcludedFromBg(slug: string): boolean {
  return BG_EXCLUDED_POST_SLUGS.has(slug);
}